import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { Text } from "@components/Text";
import { paths } from "@libs/paths";
import styles from "./index.module.css";
import type { NextPage } from "next";

const PrivacyPage: NextPage = () => {
  return (
    <CommonLayout noHeaderButton noModal hasFooter>
      <CommonHead
        title={"プライバシーポリシー"}
        ogUrl={paths.privacyPolicyForApp}
      />
      <div className={styles.privacy}>
        <main className={styles.main}>
          <div className={styles.container}>
            <div className={styles.inner}>
              <div className={styles.privacyTitle}>
                <h1>Fansta プライバシーポリシー</h1>
              </div>
              <p className={styles.privacyDate}>
                2022年2月16日 制定
                <br />
                2022年10月3日 改定
                <br />
                2022年10月24日 改定
                <br />
                2023年6月15日 改定
                <br />
                2024年10月25日 改定
              </p>
              <ul>
                <li className={styles.listItem}>
                  <div className={styles.detailText}>
                    <p>
                      株式会社MIXI（以下「当社」といいます）は、当社が提供するスマートフォン用アプリケーション「Fansta」（以下「本アプリ」といいます）および本アプリに関するサービス（以下「本サービス」といいます）をご利用になる皆様（以下「利用者」といいます）の情報を以下のように取り扱うものとします。
                    </p>
                  </div>
                </li>
                <li className={styles.listItem}>
                  <h2 className={styles.detailTitle}>
                    1. 取得情報および利用目的
                  </h2>
                  <div className={styles.detailText}>
                    <p>
                      当社は、本アプリおよび本サービスにおいて、利用者の情報を以下の目的のために利用いたします。なお、情報をご提供いただけない場合、本アプリおよび本サービスの全部あるいは一部をご利用いただけないことがございます。
                    </p>
                  </div>
                  <ul className={styles.detailList}>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>端末情報</h3>
                      <div className={styles.detailText}>
                        <p>
                          取得情報：利用者の端末を識別するIDやOSのバージョンなどの端末に関する情報
                        </p>
                        <p>取得方法：自動取得</p>
                        <p>
                          利用目的：利用者の端末に適したサービスを提供するため
                        </p>
                      </div>
                    </li>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>アカウント情報</h3>
                      <div className={styles.detailText}>
                        <p>
                          取得情報：生年月日、電話番号、メールアドレス、氏名
                        </p>
                        <p>取得方法：利用者による入力</p>
                        <p>
                          利用目的：利用者のアカウント開設、本人確認、年齢確認、本アプリおよび本サービスを利用するための情報入力の簡略化（予約者情報含む）、お問い合わせ対応、重要なお知らせや連絡のため
                        </p>
                      </div>
                    </li>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>
                        お支払いに関する情報
                      </h3>
                      <div className={styles.detailText}>
                        <p>
                          取得情報：決済履歴（決済日時・利用店舗・決済金額・決済内容・決済方法）
                        </p>
                        <p>取得方法：自動取得</p>
                        <p>利用目的：予約時の決済機能を提供するため</p>
                      </div>
                    </li>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>
                        お問い合わせに関する情報
                      </h3>
                      <div className={styles.detailText}>
                        <p>
                          取得情報：ユーザーやご利用の端末に関する情報などお問い合わせ入力フォームにて記載いただく情報、当社から追加で依頼する確認事項、メールアドレス
                        </p>
                        <p>取得方法：利用者による入力およびメール送信</p>
                        <p>
                          利用目的：お問い合わせ内容の調査、お問い合わせへの返答および本人確認のため
                        </p>
                      </div>
                    </li>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>
                        アンケートに関する情報
                      </h3>
                      <div className={styles.detailText}>
                        <p>
                          取得情報：当社が指定するアンケートフォームにて記載いただく情報
                        </p>
                        <p>取得方法：利用者による入力</p>
                        <p>
                          利用目的：利用に関する動向調査や本アプリおよび本サービスの改善、ならびに新サービスの開発のため
                        </p>
                      </div>
                    </li>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>
                        懸賞応募に関する情報
                      </h3>
                      <div className={styles.detailText}>
                        <p>
                          取得情報：当社が指定する懸賞応募フォームにて記載いただく情報
                        </p>
                        <p>取得方法：利用者による入力</p>
                        <p>
                          利用目的：懸賞の抽選や利用者へのご連絡および賞品の発送のため
                        </p>
                      </div>
                    </li>
                  </ul>
                </li>
                <li className={styles.listItem}>
                  <h2 className={styles.detailTitle}>
                    2. 外部送信・情報収集モジュールの利用
                  </h2>
                  <div className={styles.detailText}>
                    <p>
                      当社は、本アプリおよび本サービスの提供や利用に関する動向調査、利用者に適切な広告表示をするために、本アプリおよび本サービスの機能とは独立した、第三者による情報収集モジュールを利用することがあります。情報収集モジュール等の名称・サービス名、情報モジュールを提供する外部事業者および情報収取モジュール等に送信される利用者情報の内容、送信される情報の利用目的については以下をご確認ください。
                    </p>
                  </div>
                  <ul className={styles.detailList}>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>Google Analytics</h3>
                      <div className={styles.detailText}>
                        <p>
                          提供者:{" "}
                          <a
                            href="https://policies.google.com/privacy"
                            target="_blank"
                          >
                            Google LLC
                          </a>
                        </p>
                        <p>
                          利用目的：本アプリおよび本サービスの利用動向の調査のため
                        </p>
                        <p>
                          送信する項目：ファーストパーティCookie、デバイス/ブラウザ、IPアドレス、サイト内/アプリでのアクティビティ、広告識別子、HTTPリクエストログ
                        </p>
                      </div>
                    </li>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>
                        Firebase Crashlytics
                      </h3>
                      <div className={styles.detailText}>
                        <p>
                          提供者:{" "}
                          <a
                            href="https://firebase.google.com/support/privacy"
                            target="_blank"
                          >
                            Google LLC
                          </a>
                        </p>
                        <p>利用目的：本アプリのクラッシュ情報を調査するため</p>
                        <p>
                          送信する項目：
                          CrashlyticsのインストールUUID、クラッシュトレース、ユーザーの端末情報
                        </p>
                      </div>
                    </li>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>Google Tag Manager</h3>
                      <div className={styles.detailText}>
                        <p>
                          提供者:{" "}
                          <a
                            href="https://policies.google.com/privacy"
                            target="_blank"
                          >
                            Google LLC
                          </a>
                        </p>
                        <p>
                          利用目的：サービス利用動向調査のため、広告連携のため
                        </p>
                        <p>
                          送信する項目：タグの起動に関する収集データ、HTTPリクエストログ
                        </p>
                      </div>
                    </li>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>
                        Firebase Cloud Messaging
                      </h3>
                      <div className={styles.detailText}>
                        <p>
                          提供者:{" "}
                          <a
                            href="https://firebase.google.com/support/privacy"
                            target="_blank"
                          >
                            Google LLC
                          </a>
                        </p>
                        <p>利用目的：プッシュ通知配信のため</p>
                        <p>送信する項目：FirebaseインストールID</p>
                      </div>
                    </li>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>AppsFlyer</h3>
                      <div className={styles.detailText}>
                        <p>
                          提供者:{" "}
                          <a
                            href="https://www.appsflyer.com/legal/services-privacy-policy/"
                            target="_blank"
                          >
                            AppsFlyer, Inc.
                          </a>
                        </p>
                        <p>
                          利用目的：利用者に適した広告配信、及び広告掲載効果測定のため
                        </p>
                        <p>
                          送信する項目：デバイス/ブラウザ、キャリア情報、IPアドレス、位置情報（市区町村単位）、ユーザーエージェント、IDFA（iOSの場合。オプトアウト表示済み）、Android
                          ID（Androidの場合）、Google広告ID、広告クリックなどのイベント
                        </p>
                      </div>
                    </li>
                    <li className={styles.listItem}>
                      <h3 className={styles.detailTitle}>Rollbar</h3>
                      <div className={styles.detailText}>
                        <p>
                          提供者:{" "}
                          <a
                            href="https://docs.rollbar.com/docs/privacy-policy"
                            target="_blank"
                          >
                            Rollbar, Inc.
                          </a>
                        </p>
                        <p>利用目的：エラー調査のため</p>
                        <p>
                          送信する項目：デバイス/ブラウザ情報、JavaScript利用状況（cookie有効/無効,
                          Source
                          Map有効/無効、言語情報）、エラー発生時アクセス先情報（URLパラメータ含む）、IPアドレス、ブラウザ上で発生したエラー文言
                        </p>
                      </div>
                    </li>
                  </ul>
                </li>
                <li className={styles.listItem}>
                  <h2 className={styles.detailTitle}>
                    3. 利用者情報の送信停止および削除
                  </h2>
                  <div className={styles.detailText}>
                    <p>
                      本アプリは、利用者情報の自動送信を停止する手段を提供しておりません。利用者情報の自動送信を停止したい場合は、本アプリをアンインストールしてください。また、本アプリおよび本サービスは、利用者情報を当社のサーバから削除する手段を提供しておりません。
                    </p>
                  </div>
                </li>
                <li className={styles.listItem}>
                  <h2 className={styles.detailTitle}>4. 改定</h2>
                  <div className={styles.detailText}>
                    <p>
                      当社は、本プライバシーポリシーの全部または一部を改定することがあります。重要な変更がある場合には、告知することといたします。
                    </p>
                  </div>
                </li>
                <li className={styles.listItem}>
                  <h2 className={styles.detailTitle}>5. お問い合わせ先</h2>
                  <div className={styles.detailText}>
                    <p>
                      利用者情報に関するお問い合わせ先：
                      <a
                        href="https://support.fansta.jp/hc/ja/requests/new"
                        target="_blank"
                      >
                        お問い合わせ用フォーム
                      </a>
                    </p>
                  </div>
                </li>
                <li className={styles.listItem}>
                  <div className={styles.detailText}>
                    <p>
                      <Text
                        tag="span"
                        size={12}
                        bold
                        className={styles.subTitle}
                      >
                        附則
                      </Text>
                      本プライバシーポリシーに定めのない事項は
                      <a
                        href="https://mixi.co.jp/privacy/#toriatsukai"
                        target="_blank"
                      >
                        個人情報の取り扱いについて
                      </a>
                      が適用されます。
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </main>
      </div>
    </CommonLayout>
  );
};

export default PrivacyPage;
